import { FC, ReactNode } from 'react';
import { cn, FaIcon } from '@fe-learner-common';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export type TagType =
  | 'ghost'
  | 'neutral'
  | 'positive'
  | 'negative'
  | 'attention'
  | 'prominence';
interface TagProps {
  className?: string;
  children: ReactNode;
  icon?: IconDefinition;
  type?: TagType;
}

const typeMap = {
  ghost: 'bg-neutral-0 text-neutral-500',
  neutral: 'bg-neutral-100 text-neutral-550',
  positive: 'bg-positive-50 text-positive-500',
  negative: 'bg-negative-50 text-negative-500',
  attention: 'bg-attention-50 text-attention-500',
  prominence: 'bg-prominence-50 text-prominence-500',
};

export const Tag: FC<TagProps> = ({
  className,
  children,
  icon,
  type,
  ...rest
}) => {
  const typeClass = (type && typeMap[type]) || typeMap.neutral;
  return (
    <span
      className={cn(
        'inline-flex h-fit items-center gap-1 rounded-full bg-neutral-100 px-1.5 py-0.5 text-label-sm tracking-[.5px] text-neutral-550',
        typeClass,
        className,
      )}
      {...rest}
    >
      {icon && <FaIcon width={12} height={12} icon={icon} />}
      {children}
    </span>
  );
};
